// extracted by mini-css-extract-plugin
module.exports = {"header":"PageTitle_header__3ogxW","headerDark":"PageTitle_headerDark__3RZEX","logo":"PageTitle_logo__3-VcH","title":"PageTitle_title__2A7sH","subTitle":"PageTitle_subTitle__MAHYA"};